<main class="main">
  @if (!hideHeader && !(isVirtual)) {
    <app-header class="app-header"></app-header>
  }
  <div class="content">
    <!-- @if (showAngularPlayground) {
      <app-ng-playground></app-ng-playground>
    } -->
    @if (gamesLoadError) {
      <div class="race-load-banner" role="alert">
        <span>{{ gamesLoadErrorKey | translate }}</span>
        <button type="button" (click)="refreshGames()" [disabled]="racesLoading">{{ 'race_data_refresh' | translate }}</button>
      </div>
    }
    @if(loading){
      <app-spinner-loader></app-spinner-loader>
    }
    <router-outlet />
  </div>
  @if (!isMobile && !(isVirtual)) {
    <app-footer></app-footer>
  }
  <div class="scroll-to-top" [class.show-scrollTop]="windowScrolled">
      <button (click)="scrollToTop()">
          <i class="chevron-up"></i>
      </button>
  </div>
</main>

